import React, { useEffect, useState } from 'react'
import './InputFields.css';
import { Button, Checkbox, Col, DatePicker, Input, InputNumber, Row, Select, Spin, Upload } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCodeBranch, faEye, faPaperclip, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import moment from 'moment';
import ReactInputMask from 'react-input-mask';
import { UserPicker } from '../../common/UserPicker/UserPicker';
import CurrencyInput from 'react-currency-input-field';
import icon from '../../assets/images/zoho-Workdrive-tr.png';
// import icon from '../../';
import { NumericFormat } from 'react-number-format';
import { NewUserPicker } from '../../common/UserPicker/NewUserPicker';
import AwsServerService from '../../common/util/AwsServerService';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { NewCustomePopover } from '../TaskBluePrints/HelperComponents/NewCustomePopover';
import UploadComponent from '../UploadComponent/UploadComponent';
import { useDispatch, useSelector } from 'react-redux';
import HierarchicalDropdown from '../Roles/HierarchicalDropdown';
import { PushInputFieldValidation,RemoveInputFieldValidation } from '../../Context/ReduxContext';

const { Option } = Select;
export const InputFieldsTable = ({
    InputFields,
    readOnly,
    Module,
    onChange,
    deal,
    onDelete,
    onBlur,
    // handleAttachmentsForEmailAutomation,
    taskInputFieldAttachments
}) => {
    const [inputField, setInputField] = useState([]);
    // const [taskInputFieldAttachments, setTaskInputFieldAttachments] = useState([]);
    const [validation,setValidation] = useState({});
    const InputFieldValidation = useSelector((state) => state.AppReduxContext.InputFieldValidation); // Read state
    const AppReduxContextDispatch = useDispatch(); // Dispatch actions
    const validationCss={
        "transition": "width 0.4s ease-in-out",
        "box-shadow" : "rgb(255 98 98) 0px 0px 7px 1px","border-color":"#ff0000",
      }
    useEffect(()=>{
        let obj={};
        inputField?.forEach(field=>{
           if(obj[field.id]){ 
            obj[field.id]='0';
            }else{
            obj[field.id]='0';
            }
        })
        setValidation(obj);
    },[readOnly,inputField]) 
    // useEffect(()=>{
    // let type = InputFields?.hasOwnProperty('SubTaskROWID')?'SubTask':'Task';
    // let taskROWID=InputFields?.hasOwnProperty('SubTaskROWID')?InputFields?.SubTaskROWID:InputFields?.TaskROWID;
    // AwsServerService.getEmailAttachmentLink(deal?.Deal_Name,taskROWID,type).then(res=>{
    //     setTaskInputFieldAttachments(res?.data);
    // })
    // },[InputFields])
    const [fileList,setFileList] = useState([]);
    const [loading,setLoading] = useState(null);
    const [uploading,setUploading] = useState({index:null,percentage:0});
    const [errorPopConfirm, setErrorPopConfirm] = useState();
    const customUploadAction = async (options,field,path,index,oldFile) => {
        let { file, onSuccess, onError } = options;

        
        if(!path){
            path=["Documents","Task"];
        }
        let name ="";
        let extName = file.name.split(".")[1] 
        if(field.NameFormat){
            let parts = field.NameFormat.split(/(\{.*?\})/);
            parts = parts.filter(part => part !== "")

            for(const str of parts){
                if(str.includes("{") && str!="{Actual_Name}"){
                    name += deal[str.replace("{","").replace("}","")];
                }else if(str=="{Actual_Name}"){
                    name += file.name.split(".")[0];
                }else{
                    name += str;
                }
            }
            if(extName){
                name+= "."+extName;
            }
            console.log(name);
            // file = new File([file], name, {
            //     type: file.type,
            //     lastModified: file.lastModified,
            // });
        }else{
            name=file.name;
        }
        file = new File([file], name, {
            type: file.type,
            lastModified: file.lastModified,
        });
        try { 
            
            await AwsServerService.ensureFolderPathExists(deal?.zohoworkdriveforcrm__Workdrive_Folder_ID, path , localStorage.getItem('token')).then(ParentFolderId=>{
                
                if (ParentFolderId) {
                    if(oldFile && oldFile[0].folderId){
                        AwsServerService.handleRenameFolder({id:oldFile[0].folderId,renameValue:"Archive_"+oldFile[0].name},localStorage.getItem('token')).then(res=>{
                            AwsServerService.UploadFileWorkDrive(file,ParentFolderId,localStorage.getItem('token')).then(res=>{
                                  
                                // let type = InputFields?.hasOwnProperty('SubTaskROWID')?'SubTask':'Task';
                                // let taskROWID=InputFields?.hasOwnProperty('SubTaskROWID')?InputFields?.SubTaskROWID:InputFields?.TaskROWID;
                                let rowid=taskInputFieldAttachments?.filter(el=>el?.InputFieldID == field?.id)[0]?.ROWID;
                                AwsServerService.UpdateEmailAttachmentLink({ROWID:rowid,DocumentID:name+"___"+file?.res?.data?.data[0]?.attributes?.resource_id})
                                let arr = [...inputField];
                                arr[index]["value"] = 
                                    {
                                        name: file.name,
                                        folderId: res?.data?.data[0]?.attributes?.resource_id,
                                        Permalink: res?.data?.data[0]?.attributes?.Permalink
                                    }
                                ;
                                onChange(arr);
                                setLoading(null)
                                onSuccess("File uploaded successfully");
                                onBlur();
                            }).catch(e=>{
                                setLoading(null)
                                throw new Error('Upload failed');
                            })
                        })
                    }else{
                        AwsServerService.UploadFileWorkDrive(file,ParentFolderId,localStorage.getItem('token')).then(res=>{
                              
                            let type = InputFields?.hasOwnProperty('SubTaskROWID')?'SubTask':'Task';
                            let taskROWID=InputFields?.hasOwnProperty('SubTaskROWID')?InputFields?.SubTaskROWID:InputFields?.TaskROWID;
                            AwsServerService.CreateEmailAttachmentLink({DealName:deal?.Deal_Name,Type:type,TaskROWID:taskROWID,InputFieldID:field?.id,DocumentID:name+"___"+res?.data?.data[0]?.attributes?.resource_id})
                            let arr = [...inputField];
                            arr[index]["value"] = 
                                {
                                    name: file.name,
                                    folderId: res?.data?.data[0]?.attributes?.resource_id,
                                    Permalink: res?.data?.data[0]?.attributes?.Permalink
                                }
                            ;
                            // setInputField(arr);
                            onChange(arr);
                            setLoading(null)
                            onSuccess("File uploaded successfully");
                            onBlur();
                        }).catch(e=>{
                            setLoading(null)
                            throw new Error('Upload failed');
                        })
                    }
                } else {
                    setLoading(null)
                    throw new Error('Upload failed');
                }
            });

        } catch (error) {
            setLoading(null)
            onError(error);
        }
    };
    const TypeInputComponents = {
        "TEXT": (field, index) => <Input disabled={readOnly} readOnly={readOnly} className={`Input-Text ${InputFieldValidation?.includes(field?.id) && "InvalidFieldCss"}`} 
            value={field?.value}
            onBlurCapture={onBlur}
            onChange={(e) => {
                e.currentTarget.value=e.currentTarget.value.trimStart().replace(/[^a-zA-Z\s]/g,'')
                let arr = [...inputField];
                arr[index]["value"] = e?.currentTarget?.value;
                // setInputField(arr);
                if(  (e?.currentTarget?.value && e?.currentTarget?.value!='' && e?.currentTarget?.value!=undefined)){
                    setValidation({...validation,[field.id]:0})
                }
                onChange(arr,field?.Module);
            }}
            onBlur={(e)=>{
                
                if(  (!field?.value || field?.value==''|| field?.value==undefined)){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
            }}
        />,
        "CHECKBOX": (field, index) => <Checkbox disabled={readOnly} readOnly={readOnly} className={`Input-Text ${InputFieldValidation.includes(field.id) && "InvalidFieldCss"}`} 
            value={field?.value}
            onBlur={onBlur}
            onChange={(e) => {
                let arr = [...inputField];
                arr[index]["value"] = e?.target?.checked;
                // setInputField(arr);
                onChange(arr);
            }}
        />,
        "MULTI-PICKLIST": (field, index) => <Select mode='multiple' disabled={readOnly} 
        className={`Input-Select ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`} 
        rootClassName={`Input-Select ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`} 
            value={field?.value}
            onChange={(values, option) => {
                let arr = [...inputField];
                arr[index]["value"] = values;
                // setInputField(arr);
                if(  values?.length>0){
                    setValidation({...validation,[field.id]:0})
                }
                onChange(arr);
            }}
            onBlur={(e)=>{
                if(  !field?.value?.length>0){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
                onBlur(e);
            }}
            allowClear 
        >
            {field?.ExtraData?.map((option, idx) => (
                <Option key={idx} value={option?.id}>
                    {option.text}
                </Option>
            ))}
        </Select>,
        "PHONE": (field, index) => <ReactInputMask
            disabled={readOnly} readOnly={readOnly}
            // style={validation[field.id]==-1?validationCss:{}}
            type="text"
            mask="(999) 999-9999"
            maskChar='_'
            className={`form-control arrow-hide createdeal-textfield ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`}
            name="phoneNumber" id="phoneno"
            placeholder="(###) ###-####"
            minLength={3}
            value={field.value ? field.value : ''}
            // style={validation.phoneNumber=='-1'?{...validationCss}:{}}
            onKeyDown={(evt) =>
                ((evt.keyCode > 64 && evt.keyCode < 91) || evt.key === ".") &&
                evt.preventDefault()
            } 
        onChange={(e) => {
    e.target.value = e.target.value.trimStart();
    let value = e?.target?.value
    let value1 = value.replace(/[-#*$+/?=%() ]/g, '')
    let onlyNo = value1.replace(/\D/g, '');

    if (onlyNo.length > 10) return;

    let arr = [...inputField];
    arr[index]["value"] = value;
    onChange(arr);

    if (onlyNo.length < 10) {
        AppReduxContextDispatch(PushInputFieldValidation(field.id));
    } else {
        AppReduxContextDispatch(RemoveInputFieldValidation(field.id));
    }
}}

     onBlur={(e) => {
    let value = e?.currentTarget?.value?.replace(/\D/g, '');
    if (value?.length < 10) {
        AppReduxContextDispatch(PushInputFieldValidation(field.id));
    } else {
        AppReduxContextDispatch(RemoveInputFieldValidation(field.id));
    }
    onBlur(e);
}}

        />,
        "NUMBER": (field, index) => <InputNumber style={{ width: "100%" }} min={0}
            step={field?.Precision ? Number(field?.Precision) : 1}
            precision={field?.Precision ? field?.Precision?.split(".")[1]?.length : 0}
            disabled={readOnly}
            readOnly={readOnly}
            className={`Input-Text ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`}
            value={field?.value}
       onChange={(e) => {
    e.target.value = e.target.value.trimStart();
    let value = e?.target?.value
    let value1 = value.replace(/[-#*$+/?=%() ]/g, '')
    let onlyNo = value1.replace(/\D/g, '');

    if (onlyNo.length > 10) return;

    let arr = [...inputField];
    arr[index]["value"] = value;
    onChange(arr);

    if (onlyNo.length < 10 && onlyNo.length > 0) {
        AppReduxContextDispatch(PushInputFieldValidation(field.id));
    } else if (onlyNo.length === 10) {
        AppReduxContextDispatch(RemoveInputFieldValidation(field.id));
    }
}}

onBlur={(e) => {
    let value = e?.currentTarget?.value?.replace(/\D/g, '');
    if (value?.length < 10 && value?.length > 0) {
        AppReduxContextDispatch(PushInputFieldValidation(field.id));
    } else if (value?.length === 10) {
        AppReduxContextDispatch(RemoveInputFieldValidation(field.id));
    }
    onBlur(e);
}}

        />,
        "CURRENCY": (field, index) => <NumericFormat 
        className={`custome-currency-input ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`}
        name="currency"
        step={field?.Precision ? Number(field?.Precision) : 1}
        placeholder="Enter amount"
        value={field?.last}
        defaultValue={0}
        thousandSeparator
        disabled={readOnly}
        readOnly={readOnly}
        decimalScale={field?.Precision}
style={{
  background: "#ecebeb",
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#d9d9d9',
  borderRadius: '6px',
  width: '100%',
  height: '33px',
  boxSizing: 'border-box'
}}

        onValueChange={(e) => {
            let arr = [...inputField];
            arr[index]["value"] = e.floatValue;
            // setInputField(arr);
            if(  (e.value && e.value!='' && e.value!="$0")){
                setValidation({...validation,[field.id]:0})
            }
            onChange(arr);
        }}
        onBlur={(e)=>{
            
            if(  (!field?.value || field?.value=='' || field?.value==undefined)){
                setValidation({...validation,[field.id]:-1})
            }else{
                setValidation({...validation,[field.id]:0})
            }
            onBlur(e);
        }}
        prefix="$"
      />,
        "USER": (field, index) => <NewUserPicker
            readOnly={readOnly}
            rootClassName={`${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`}
            mode="multiple"
            values={field?.value}
            style={validation[field.id]==-1?validationCss:null}
            onBlur={e=>{
                if(  (!field?.value || field?.value=='' || field?.value==undefined)){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
                onBlur(e);
            }}
            onChange={(val) =>{
                let arr = [...inputField];
                arr[index]["value"] = val;
                if(  (!val || val.length==0)){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
                onChange(arr);
            }} 
        />,
        "ATTACHMENT": (field, index) => <div style={{display:"flex",alignItems:"center"}}>
            <Upload.Dragger 
                showUploadList={false}
                className={`Upload-Attachment ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`}
                multiple={true}
                disabled={readOnly}
                onRemove={e=>{
                    
                    setLoading(index);
                    setErrorPopConfirm({msg:"Are you sure you want to delete this attachment?",index:index,data:e});
                }}
                fileList={field?.value?[field.value]:[]}
                style={{display:"flex",flexDirection:"row",width:"25rem"}}
                // beforeUpload={()=>{}}
                customRequest={(props) => {
                    // handleAttachmentsForEmailAutomation(props.file);
                    setLoading(index);
                    customUploadAction(props, field ,field?.AttachmentPath?.path?.replace("/Deal Directory/", "")?.split("/"), index, field.value);
                }}
                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            >
                <p className="ant-upload-text" style={{ color: '#5b6c97' }}>
                    {loading == index ? <Spin /> :
                        (field?.value && field?.value?.name) ? <>
                            {!(field?.value?.name) &&
                                <InboxOutlined />
                            }
                            <FontAwesomeIcon className='mr-1' icon={faPaperclip} />{field?.value?.name}
                        </> : "Click or drag file to this area to upload"}

                </p>
            </Upload.Dragger>
            {(field?.value && field?.value?.Permalink) && 
                <img style={{ width: "auto", height: "34px", cursor: 'pointer' }} onClick={() => window.open(field?.value?.Permalink)} src={icon} />
            }
            {(field?.value && field?.value?.Permalink) && <FontAwesomeIcon
                onClick={e => {
                    setLoading(index);
                    setErrorPopConfirm({ msg: "Are you sure you want to delete this attachment?", index: index, data: field?.value });
                }}
                className='ml-2' color='red' icon={faTrashAlt} />}
           
        </div>,
        "DATE": (field, index) => <><DatePicker 
            className={`Input-Date ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`} 
            disabled={readOnly} readOnly={readOnly}
            format="MM/DD/YYYY"
            // style={validation[field.id]==-1?validationCss:{}}
            onBlur={e=>{
                if(  !field.value){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
            }}
            value={field?.value ? dayjs(field.value) : dayjs(new Date())}
            onChange={(date, dateString) => {
                
                let arr = [...inputField];
                arr[index]["value"] = dateString;
                if(  !dateString){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
                // setInputField(arr);
                onChange(arr);
            }} 
        ></DatePicker></>,
        "PICKLIST": (field, index) => <Select disabled={readOnly} className={`Input-Select ${InputFieldValidation?.includes(field.id) && "InvalidFieldCss"}`} 
            value={field?.value}
            onChange={(value) => {
                let arr = [...inputField];
                arr[index]["value"] = value;
                // setInputField(arr);
                if(  !value){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
                onChange(arr);
            }}
            // onSelect={(value, option) => {
            //     let arr=[...inputField];
            //     arr[index]["value"]= value;
            //     setInputField(arr);
            // }}
            onBlur={(e)=>{
                if(  !field.value){
                    setValidation({...validation,[field.id]:-1})
                }else{
                    setValidation({...validation,[field.id]:0})
                }
            }}
            allowClear
        >
            {field?.ExtraData?.map((option, idx) => (
                <Option key={idx} value={option?.id}>
                    {option?.text}
                </Option>
            ))}
        </Select>,
        "ROLE":(field, index) => <HierarchicalDropdown
            styles={{width:'100%',height:'auto'}}
            disabledCondition={readOnly}
            key={"rolepicker"+index}
            GroupName={["Zoho","Role"]}
            handleChangeUser={(value, option) => {
                let arr = [...inputField];
                arr[index]["value"] = value;
                onChange(arr);
            }}
            
            selectedUsers={field?.value}
        />
    }
    useEffect(e => {
         
        if (Module == "TASK") {
              
            let arr = []
            if (InputFields?.InputFields && InputFields?.InputFields?.length > 0) {
                arr = [...InputFields?.InputFields];
            }
            if (InputFields?.TaskFlowObject?.InputFields && InputFields?.TaskFlowObject?.InputFields?.length > 0) {
                arr = [...arr, ...InputFields.TaskFlowObject.InputFields];
            }
            setInputField(arr);
            // onChange(arr);
        } else {
            if (InputFields && InputFields.length > 0) {
                setInputField([...InputFields]);
                // onChange(InputFields);
            } else {
                setInputField([]);
                // onChange([]);
            }
        }
    }, [InputFields, Module])
//     useEffect(() => {
//     inputField?.forEach((field) => {
//         if (field.Type === "PHONE") {
//             const digitsOnly = field?.value?.replace(/\D/g, '') || '';
//             if (digitsOnly.length === 10) {
//                 AppReduxContextDispatch(RemoveInputFieldValidation(field.id));
//             } else {
//                 AppReduxContextDispatch(PushInputFieldValidation(field.id));
//             }
//         }
//     });
// }, [inputField]);
console.log("input data", inputField);
    return (
        <div style={{ paddingBottom: "4px" }}>
            <NewCustomePopover
                width={30}
                open={errorPopConfirm}
                title={"Warning!"}
                okText={"OK"}
                cancelText={"Cancel"}
                onCancel={e => {
                    setLoading(null);
                    setErrorPopConfirm(null)
                }}
                onOk={e => {
                    if(errorPopConfirm?.data?.folderId){

                        AwsServerService.handleRenameFolder({id:errorPopConfirm?.data?.folderId,renameValue:"Archive_"+errorPopConfirm?.data?.name},localStorage.getItem('token')).then(res=>{
                            let arr = [...inputField];
                            arr[errorPopConfirm?.index]["value"] = null;
                            setLoading(null);
                            onChange(arr);
                            setTimeout(()=>{
                                onBlur();
                            },1000) 
                             
                            let rowid=taskInputFieldAttachments?.filter(el=>el?.DocumentID?.split('___')[1]==errorPopConfirm?.data?.folderId)[0]?.ROWID;
                            AwsServerService.DeleteEmailAttachmentLink(rowid);
                        })
                    }
                    setLoading(null);
                    setErrorPopConfirm(null)
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div className='Msg-Block'>
                    {errorPopConfirm?.msg}
                </div>
            </NewCustomePopover>
            <div className='InputFields-Table-Wrapper'>
                {inputField?.map((field, i) => {
                    
                    if (TypeInputComponents[field?.Type]) {
                        return (<Row style={{ backgroundColor: "transparent" }} className='Field-Verticle-Row' sm={12}>
                            <Col className='Field-Name' sm={6}>
                                {field.Module == "TASKFLOW" ? <FontAwesomeIcon className='mr-1 ml-1' color="#7a7a7a" icon={faCodeBranch} /> : <FontAwesomeIcon className='mr-1 ml-1' color="transparent" icon={faCodeBranch} />}
                                {field?.Name?.toUpperCase()} 
                                {/* {field?.Mandatory && <span className='ml-1' style={{ color: 'red' }}>*</span>} */}
                            </Col>
                            <Col className='Field-Value' sm={field.Type != "ATTACHMENT" && 6}>{TypeInputComponents[field?.Type](field, i)}</Col>
                            {field.Module != "TASKFLOW" && <FontAwesomeIcon onClick={e => {
                                onDelete(field);
                            }} className='Delete-Icon-For-Field' color='red' icon={faTrashAlt}></FontAwesomeIcon>}
                        </Row>)
                    }
                })}
                {/* <Row className='Field-Verticle-Row' sm={12}>
                    <Col className='Field-Name' sm={6}>Name</Col>
                    <Col className='Field-Value' sm={6}>test</Col>
                </Row> */}
            </div>
        </div>
    )
}
